module.exports = __webpack_public_path__ + "images/products/4-flavors-9dc959dc.png";